module.exports = __webpack_public_path__ + "img/bitcoin-btc-gold.f8b97dcf.svg";